// extracted by css-extract-rspack-plugin
export default {"AttachmentSwitchBody":"w8KYv","AttachmentSwitchInput":"PZg1w"};